import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * WHO made an audit entry: the user — and, when the super admin did it
 * through «Увійти як користувач», the super admin beside them
 * (`impersonatorUsername`, api/src/Security/Impersonation.php).
 */
const AuditAuthor = ({ log }) => {
    const [t] = useTranslation();
    const name = log.changedByDisplayName || log.changedByUsername || '—';

    if (!log.impersonatorUsername) {
        return <>{name}</>;
    }

    return (
        <>
            {name}
            {' '}
            <span data-testid="audit-impersonator">
                ({t('impersonation.by', { username: log.impersonatorUsername })})
            </span>
        </>
    );
};

AuditAuthor.propTypes = {
    log: PropTypes.shape({
        changedByDisplayName: PropTypes.string,
        changedByUsername: PropTypes.string,
        impersonatorUsername: PropTypes.string,
    }).isRequired,
};

export default AuditAuthor;
